import axios from 'axios';
import _ from 'lodash';
import { createUserQuery } from './queries';
import { fetchRegionFromBackend } from '../../utils/regionConfig';
import { buildExpressQuery } from './queries/builders';

const uuidv4 = require('uuid/v4');

const addUser = async (model) => {
    try {
        // Fetch the correct region from the backend before creating the user
        // This ensures dev/staging environments use the correct region (e.g., UDA)
        // instead of the dev environment name (e.g., TLEWIS-MM)
        const region = await fetchRegionFromBackend();

        const userModel = _.omit(model, 'password_confirmation');
        // coerce username to lowercase on both login + signup
        if (userModel.username) {
            userModel.username = userModel.username.toLowerCase();
        }
        // Set the region from the backend
        userModel.region = region;

        // PFM-3029: LoopBack is retired; user creation is Express-only
        // (use_express_auth_endpoints is unconditionally on — MD-136).
        const query = createUserQuery({ model: userModel, queryBuilder: buildExpressQuery });
        // PFM-2799: one key per submission. A retry of the same submission
        // replays the committed user instead of provisioning a duplicate; a new
        // submission gets a new key. The server scopes it to the authenticated
        // actor and region, so it is an opaque correlation value, not a secret.
        const response = await axios.post(
            query.url,
            { ...query.body },
            {
                headers: { 'Idempotency-Key': uuidv4() },
            }
        );

        return { data: response.data };
    } catch (error) {
        const message = error?.response?.data?.message || error?.response?.data?.error?.message || error?.response?.data?.error || error?.message;
        if (message) {
            const formattedError = new Error(message);
            formattedError.statusCode = error?.response?.status || error?.statusCode;
            formattedError.response = error?.response;
            // PFM-3029: forward machine-readable details so forms can detect
            // the confirmed-link offer (details.linkAvailable) without
            // string-matching messages.
            formattedError.details = error?.response?.data?.details ?? error?.response?.data?.error?.details;
            throw formattedError;
        }
        throw error;
    }
};

export default addUser;
